import { Button } from '@components/Button';
import Typography from '@components/Typography';
import ResetFilters from './ResetFilters';

export const NoResults = () => {
  return (
    <div className="my-8 flex flex-col items-start gap-y-4 rounded-md bg-brand-sand p-8">
      <Typography tag="h2" size="text-xl">
        Sorry we can't find any results for your search, try resetting the
        filters and starting again
      </Typography>
      <Button variant="default" size="lg" className="text-white">
        <ResetFilters />
      </Button>
    </div>
  );
};
